export const iconFontAwesomeBuildingsGopuram = (
	<i className="fa-solid fa-gopuram"></i>
);
